module.exports = "app-cfc-checkbox-editor form {\n  padding-left: 11px;\n  padding-right: 11px;\n  line-height: 27px;\n}\n"